module.exports = "/images/checkbox-base-pink.svg?c644f7d6e7654ef118be91204b7d5968";